/* eslint-disable import/prefer-default-export */
import { styled } from '@mui/material';
import Chip from '@mui/material/Chip';
import MuiTableCell from '@mui/material/TableCell';

export const StyledMuiTableHeadCell = styled(MuiTableCell)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette['Colors/Background/bg-secondary'],
  ...theme.typography.textXs,
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  color: theme.palette['Component colors/Utility/Gray/utility-gray-800'],
  textTransform: 'capitalize',

  border: `1px solid ${theme.palette['Component colors/Utility/Gray/utility-gray-200']}`,
  ...theme.typography.textXs,

  backgroundColor:
    theme.palette['Component colors/Utility/Gray/utility-gray-50'],
}));
